<template>
    <div component="AdminHeader">
        <admin-menu-list />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AdminMenuList from '@/components/Admin/AdminMenuList.vue';

export default {
    name: 'AdminHeader',

    props: {},

    mounted() {},

    computed: {
        ...mapGetters({
            user: 'getUser',
        }),
    },

    components: {
        AdminMenuList,
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='AdminHeader'] {
    border-radius: 20px 0px 0px 20px;
    background: @primary;

    .v-list-item {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        min-height: auto;
    }
}

[component='AdminHeader'] {
    transition: 0.5s;
    position: relative;
    height: 100vw;
    width: 100%;
    top: 0;

    @media (min-width: 769px) {
        height: auto;
        width: 25%;
        overflow: hidden;
        margin: 0;
    }

    &[disabled] {
        filter: blur(5px);
        pointer-events: none;
    }

    h1 {
        .flex-center;
        padding: 0;
        position: absolute;
        z-index: 7;
        width: 100%;
        top: 40px;
        transition: 1s;

        @media @landscape and (max-height: 400px) {
            font-size: 18px;
        }
    }
}

// NA MOBILE SA NA DETAILE SKRÝVA

[component='AdminHeader'][detail='true'] {
    @media (max-width: 768px) {
        height: 80px;
        margin: 0;
        // position: absolute;

        [component='Visualizer'] {
            height: 100%;

            canvas {
                top: -30px !important;
            }
        }

        h1 {
            top: -100px;
        }

        [block='navigation'] {
            top: 0;
            margin-top: -100%;
            opacity: 0;
            transition-delay: 0s;
        }
    }
}
</style>
